'use strict';
const _ = require('underscore');
module.exports = function isEmptyGroup(contentIdea) {
	return contentIdea.attr && contentIdea.attr.group && _.isEmpty(contentIdea.ideas);
};
